import React, { useEffect, useState } from 'react';
import { Box, ButtonBase, InputBase, makeStyles } from '@material-ui/core';
import moment from 'moment';
import { AutoCompleteInput } from '../../../../../components';
import Text from '../../../../../components/Text';
import { SearchIcon } from '../../../../../components/Icon';
import { ReactComponent as SwitchOn } from '../../../../../static/images/SwitchOn.svg';
import { ReactComponent as SwitchOff } from '../../../../../static/images/SwitchOff.svg';
import CustomDateTimePicker from '../../../../../components/DatePicker/CustomDateTimePicker';
import AutoCompleteMultiCheckbox from '../../../../../components/AutoCompleteMultiCheckbox';
import { BrowserAlertByFilter } from '../../ActionableHeader';
import AeNoScanInput from '../../../components/AeNoScanInput';

const AckHistoryFilter = ({
  specialtyList,
  filter,
  handleFilterSelect,
  GENDER,
  WT,
  handleReset,
  isBsMode,
  historySubTabValue,
  busstopList,
  handleAeNoBarcodeScan,
}) => {
  const classes = useStyles();
  const [ackBy, setCorpId] = useState(filter.ackBy);

  useEffect(() => {
    setCorpId(filter.ackBy);
  }, [filter]);

  return (
    <Box display="flex" gridGap="0.75rem" alignItems="center" flexWrap="wrap">
      <Box display="flex" gridGap="0.75rem" alignItems="center" flexWrap="wrap">
        <Text color="#3E3E3E" fontSize="1rem">
          Ack. Date:
        </Text>
        <Box display="flex" alignItems="center" gridGap="0.75rem">
          <CustomDateTimePicker
            height="2.5625rem"
            value={filter.startDate}
            onChange={handleFilterSelect('startDate')}
            format="DD-MM-YYYY HH:mm"
            placeholder="StartDate"
            maxDate={moment(filter.endDate)}
            maxDateMessage={`Start date cannot be later than end date (Cannot be late than ${moment(
              filter.endDate
            )?.format?.('DD-MM-YYYY HH:mm')}).`}
            minDate={moment(filter.endDate).subtract(3, 'days')}
            strictCompareDates={true}
            minDateMessage="Start date and end date cannot be over 3 days."
          />
          <Text color="#3E3E3E" fontSize="1rem">
            -
          </Text>
          <CustomDateTimePicker
            height="2.5625rem"
            value={filter.endDate}
            onChange={handleFilterSelect('endDate')}
            format="DD-MM-YYYY HH:mm"
            placeholder="EndDate"
          />
        </Box>
        <div className={classes.search} style={{ marginTop: '1rem', marginBottom: '1rem' }}>
          <InputBase
            placeholder="CORP ID"
            value={ackBy}
            onChange={(event) => {
              setCorpId(event.target.value);
              handleFilterSelect('ackBy')(event.target.value);
            }}
          />
          <ButtonBase className={classes.searchBtn}>
            <SearchIcon style={{ fontSize: '1.125rem' }} />
          </ButtonBase>
        </div>
        <ButtonBase
          className={classes.forMyAction}
          onClick={() => {
            handleFilterSelect('corpId')();
          }}
        >
          My Ack.
          {filter.corpId ? <SwitchOn className={classes.switch} /> : <SwitchOff className={classes.switch} />}
        </ButtonBase>
      </Box>
      {!(isBsMode && historySubTabValue !== 0) && (
        <Box display="flex" gridGap="0.75rem" alignItems="center" flexWrap="wrap">
          <Text color="#3E3E3E" fontSize="1rem">
            Filter:
          </Text>
          <AutoCompleteMultiCheckbox
            itemList={specialtyList}
            value={filter.specialtys}
            onChange={handleFilterSelect('specialtys')}
            width="11.4375rem"
            height="2.5625rem"
            placeholder="Specialty"
            freeSolo
            highlight="#FFFFCC"
            selectAll={false}
          />
          <AutoCompleteInput
            itemList={GENDER}
            value={filter.sex}
            onChange={handleFilterSelect('sex')}
            width="11.4375rem"
            height="2.5625rem"
            placeholder="Gender"
            highlight="#FFFFCC"
          />
          <AutoCompleteInput
            itemList={WT}
            value={filter.waitTime}
            onChange={handleFilterSelect('waitTime')}
            width="11.4375rem"
            height="2.5625rem"
            placeholder="W.T."
            highlight="#FFFFCC"
          />
          <AutoCompleteMultiCheckbox
            itemList={busstopList}
            value={filter.busstop}
            onChange={handleFilterSelect('busstop')}
            width="15rem"
            height="2.5625rem"
            placeholder="Bus Stop"
            freeSolo
            highlight="#FFFFCC"
            selectAll={false}
          />
          <AeNoScanInput
            value={filter?.aeNo}
            onChange={handleFilterSelect('aeNo')}
            onBarcodeScan={handleAeNoBarcodeScan}
          />
          <ButtonBase className={classes.reset} onClick={handleReset}>
            Reset
          </ButtonBase>
          <BrowserAlertByFilter />
        </Box>
      )}
    </Box>
  );
};

const useStyles = makeStyles(() => ({
  reset: {
    color: '#538FFF',
    fontSize: '1rem',
    textDecoration: 'underline',
    fontFamily: 'NotoSans-Bold',
  },
  search: {
    width: '13.188rem',
    height: '2.563rem',
    borderRadius: '0.5rem',
    border: 'solid 1px #e4e7eb',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0 0.313rem 0 0.938rem',
    '& .MuiInputBase-input': {
      fontSize: '1rem',
      color: '#2e4469',
      fontFamily: 'NotoSans-Medium',
    },
  },
  searchBtn: {
    width: '1.875rem',
    height: '1.875rem',
    borderRadius: '0.5rem',
    backgroundColor: '#4c93ff',
    color: '#fff',
    fontSize: '1.125rem',
    flex: '0 0 1.875rem',
  },
  switch: {
    width: '2.75rem',
    height: '1.47rem',
  },
  forMyAction: {
    backgroundColor: '#FDFEFF',
    fontSize: '0.875rem',
    color: '#7D86A9',
    gap: '0.3rem',
    fontFamily: 'NotoSans-Medium',
  },
}));

export default AckHistoryFilter;
